// src/Components/PackageItem.jsx

import React, { useState } from 'react';
import './PackageItem.css';

const DAY_ORDER = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];

const PackageItem = ({ id, title, price, isPureVeg, imageUrl, weeklyMenu, isSelected, onSelect }) => {
    const [isMenuVisible, setIsMenuVisible] = useState(false);

    // The component now uses the weeklyMenu prop directly
    const menu = weeklyMenu || {};

    return (
        <>
            <div className={`package-item-wrapper ${isSelected ? 'selected' : ''}`}>
                <div className="package-item-container">
                    <div className="package-item-image">
                        <img src={imageUrl || 'https://via.placeholder.com/150'} alt={title} />
                    </div>
                    <div className="package-item-details">
                        <h4 className="package-item-title">{title}</h4>
                        <p className="package-item-price">₹{price}/Day</p>
                    </div>
                    <div className="package-item-actions">
                        <button 
                            className={`select-btn ${isSelected ? 'selected' : ''}`}
                            onClick={onSelect}
                        >
                            {isSelected ? '✓ Selected' : 'Select'}
                        </button>
                        <button className="view-menu-btn" onClick={() => setIsMenuVisible(true)}>
                            View Menu ⌄
                        </button>
                    </div>
                </div>
            </div>
            
            {/* Menu Popup */}
            {isMenuVisible && (
                <div className="menu-popup-overlay" onClick={() => setIsMenuVisible(false)}>
                    <div className="menu-popup-content" onClick={(e) => e.stopPropagation()}>
                        <div className="menu-popup-header">
                            <h3>{title} Menu</h3>
                            <button className="close-popup-btn" onClick={() => setIsMenuVisible(false)}>
                                ×
                            </button>
                        </div>
                        <div className="weekly-menu-container">
                            <div className="weekly-menu-grid">
                                {DAY_ORDER.map(day => (
                                    <div key={day} className="menu-day-item">
                                        <div className="day-icon">
                                            {day.charAt(0)}
                                        </div>
                                        <div className="day-details">
                                            <p className="day-name">{day}</p>
                                            {/* ✅ WRAPPED THE MEAL NAME IN A DIV FOR STYLING */}
                                            <div className="meal-name-wrapper">
                                                <p className="meal-name">{menu[day] || "Not Available"}</p>
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </>
    );
};

export default PackageItem;